var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4799 6.64149C13.4799 5.3048 12.9489 4.02285 12.0037 3.07767C11.0585 2.13248 9.77657 1.60149 8.43988 1.60149C7.10319 1.60149 5.82125 2.13248 4.87606 3.07767C3.93088 4.02285 3.39988 5.3048 3.39988 6.64149C3.39988 12.5215 0.879883 14.2015 0.879883 14.2015H15.9999C15.9999 14.2015 13.4799 12.5215 13.4799 6.64149Z",
    stroke: "#211E1F",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89273 17.5615C9.74505 17.8161 9.53308 18.0274 9.27804 18.1743C9.023 18.3212 8.73385 18.3985 8.43953 18.3985C8.14521 18.3985 7.85606 18.3212 7.60102 18.1743C7.34598 18.0274 7.13401 17.8161 6.98633 17.5615",
    stroke: "#211E1F",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.1e090c46a96703c661be6a05bfefbfb5.svg";
export { ForwardRef as ReactComponent };